import { render, staticRenderFns } from "./certificateDIY.vue?vue&type=template&id=44939a5d&scoped=true"
import script from "./certificateDIY.vue?vue&type=script&lang=js"
export * from "./certificateDIY.vue?vue&type=script&lang=js"
import style0 from "./certificateDIY.vue?vue&type=style&index=0&id=44939a5d&prod&lang=scss&scoped=true"
import style1 from "./certificateDIY.vue?vue&type=style&index=1&id=44939a5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44939a5d",
  null
  
)

export default component.exports